<template>
    <div>
        <sweet-modal icon="info" ref="infoModal" :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" blocking>
            <small class="text-center w-100 mt-3">
                {{infoMessage}}
            </small>
        </sweet-modal>
    </div>
</template>

<script>
    import { EventBus } from '../../event/event-bus.js';

    export default {
        data() {
            return {
                infoMessage: ""
            }
        },
        created() {
            EventBus.$on('emit-info', event => {
                this.infoMessage = event ?? "Item not found";
                this.$refs.infoModal.open();
            });
        },
    };
</script>
